<div class="container-fluid profile-page py-4">
  <div class="row align-items-stretch">

    <div class="col-lg-4 col-md-5 mb-4 mb-md-0">
      <div class="card shadow-sm profile-sidebar h-100 border-0 overflow-hidden d-flex flex-column">

        <div class="sidebar-banner"></div>

        <div class="card-body p-4 text-center d-flex flex-column align-items-center flex-grow-1">
          <div class="avatar-wrapper mx-auto mb-3">
            <input hidden (change)="fileEvent($event)" #fileInput name="logo" type="file" accept="image/*">

            <div class="avatar-image-container shadow-sm" (click)="fileInput.click()">
              <img *ngIf="imgURL" class="profile-avatar" [src]="imgURL" alt="Profile Photo" />
              <img *ngIf="!imgURL" class="profile-avatar" src="../../../assets/images/user-profile.jpg"
                alt="Default Profile" />

              <div class="avatar-overlay">
                <i class="fas fa-camera mb-1"></i> <span style="font-size: 11px;">{{'CHANGE_PHOTO' | translate}}</span>
              </div>
            </div>

            <button *ngIf="imgURL" type="button" class="btn btn-danger btn-sm remove-photo-btn" (click)="removeImage()"
              title="{{'REMOVE_PHOTO' | translate}}">
              <i class="fas fa-trash-alt"></i>
            </button>
          </div>

          <h5 class="user-name  mb-1">
            {{ userForm.get('firstName')?.value || 'User' }} {{ userForm.get('lastName')?.value || '' }}
          </h5>
          <p class="text-muted mb-4">{{ userForm.get('email')?.value || 'Update your details' }}</p>

          <div *ngIf="!user?.provider" class="w-100 mt-auto pt-4 border-top">
            <button class="btn btn-outline-primary w-100 rounded-pill" (click)="changePassword()">
              <i class="fas fa-key me-2 mr-2"></i> {{'CHANGE_PASSWORD' | translate}}
            </button>
          </div>
        </div>

      </div>
    </div>

    <div class="col-lg-8 col-md-7">
      <div class="card shadow-sm h-100 border-0 d-flex flex-column">
        <div class="card-header bg-white border-bottom py-3">
          <h5 class="mb-0 text-dark"><i class="fas fa-user-edit me-2 mr-2"></i> Edit Details</h5>
        </div>

        <div class="card-body p-4 d-flex flex-column flex-grow-1 form-scroll-area">
          <form [formGroup]="userForm" class="d-flex flex-column h-100">
            <div class="row flex-grow-1">

              <div class="col-md-6 mb-3">
                <div class="form-group modern-input">
                  <label class="form-label text-muted">{{'FIRST_NAME' | translate}} <span
                      class="text-danger">*</span></label>
                  <input formControlName="firstName" class="form-control custom-input" type="text"
                    placeholder="Enter first name">
                  <div *ngIf="userForm.get('firstName').touched && userForm.get('firstName').errors"
                    class="invalid-feedback d-block">
                    <div *ngIf="userForm.get('firstName').errors?.required">
                      <i class="fas fa-exclamation-circle"></i> {{'FIRST_NAME_IS_REQUIRED' | translate}}
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-6 mb-3">
                <div class="form-group modern-input">
                  <label class="form-label text-muted">{{'LAST_NAME' | translate}} <span
                      class="text-danger">*</span></label>
                  <input formControlName="lastName" class="form-control custom-input" type="text"
                    placeholder="Enter last name">
                  <div *ngIf="userForm.get('lastName').touched && userForm.get('lastName').errors"
                    class="invalid-feedback d-block">
                    <div *ngIf="userForm.get('lastName').errors?.required">
                      <i class="fas fa-exclamation-circle"></i> {{'LAST_NAME_IS_REQUIRED' | translate}}
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-6 mb-3">
                <div class="form-group modern-input">
                  <label class="form-label text-muted">{{'MOBILE_NUMBER' | translate}} <span
                      class="text-danger">*</span></label>
                  <input formControlName="phoneNumber" class="form-control custom-input" type="number"
                    placeholder="Enter mobile number">
                  <div *ngIf="userForm.get('phoneNumber').touched && userForm.get('phoneNumber').errors"
                    class="invalid-feedback d-block">
                    <div *ngIf="userForm.get('phoneNumber').errors?.required">
                      <i class="fas fa-exclamation-circle"></i> {{'MOBILE_IS_REQUIRED' | translate}}
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-6 mb-3">
                <div class="form-group modern-input">
                  <label class="form-label text-muted">{{'EMAIL' | translate}}</label>
                  <input [attr.disabled]="true" formControlName="email" class="form-control custom-input bg-light"
                    type="email">
                </div>
              </div>

              <div class="col-md-12 mb-4">
                <div class="form-group modern-input h-100 d-flex flex-column">
                  <label class="form-label text-muted">{{'ADDRESS' | translate}}</label>
                  <textarea formControlName="address" class="form-control custom-input flex-grow-1" rows="5"
                    placeholder="Enter full address"></textarea>
                </div>
              </div>

            </div>

            <div class="d-flex justify-content-end pt-3 mt-auto border-top w-100">
              <button type="button" class="btn btn-danger px-4 me-2 mr-2" [routerLink]="['/']">
                <i class="fas fa-times-circle me-1 mr-1"></i> {{'CANCEL' | translate}}
              </button>
              <button class="btn btn-success px-4 shadow-sm" (click)="updateProfile()" cdkFocusInitial>
                <i class="fas fa-save me-1 mr-1"></i> {{'SAVE' | translate}}
              </button>
            </div>

          </form>
        </div>
      </div>
    </div>

  </div>
</div>